import React from "react";
//import "./Layout.css";

// Importing all created components


import FooterDefault from "./Footer";
import SideMenu from "./SideMenu";
import { Col, Container, Row } from "react-bootstrap";
import NavDefault from "./Nav";

// Pass the child props
const Layout = (  {children} ) => {
  return (
    <div>
      <NavDefault></NavDefault>

      <Container fluid>
            <Row>
                <Col  id="sideBar" className='col-auto bg-dark d-flex flex-column justify-content-between min-vh-100' sm={2} md={2} >
                    <SideMenu/>
                </Col>
                <Col sm={9} md={9} lg={9}>
                        {children}
                </Col>
                <Col sm={1} md={1} lg={1}>
                </Col>
            </Row>
        </Container>
        <FooterDefault />
    </div>
  );
};
export default Layout;